module.exports = __webpack_public_path__ + "static/media/N3.4c31017e.jpg";